import api from "@/api/apiAlarm";
import { getTimeZone, convertTimeZone } from "@/utils/localeTime";

export default {
  namespaced: true,
  state() {
    return {
      // 이전에 선택한 알람 활성화 상태 및 알람음 조회
      volatAlarm: [],

      // 알람음 변경
      volatChk: false, // 알람 활성화 상태
      selectVolat: 1, // 알람음 id
      clickVolat: "기본음", // 기본음 or Sound N

      // Histories
      volHist: [],
    };
  },
  mutations: {
    // 알람음 변경시 id 반영
    chooseVolat(state, value) {
      state.selectVolat = value;
    },
    // 알람음 변경시 기본음/Sound N 반영
    changeVolat(state, value) {
      state.clickVolat = value;
    },
    // 알람 활성화 상태 변경
    changeActiveVol(state, payload) {
      state.volatChk = payload.state;
    },
  },
  actions: {
    // 이전에 선택한 알람음 조회 및 적용
    async getAlarmVolat(context) {
      try {
        const result = await api.getVolatSound();

        if (result.isSuccess) {
          let data = result.data;
          context.state.volatAlarm = data;
          context.commit("changeActiveVol", { state: data.active });
          if (data.display.split(" ")[2] === undefined) {
            context.state.selectVolat = 1;
          } else {
            context.state.selectVolat = Number(data.display.split(" ")[2]) + 1;
          }
        }
      } catch (error) {
        // // console.log("getAlarmVolat ", error);
        return;
      }
    },

    // Histories
    async getHistVol(context) {
      try {
        const result = await api.getVolHistory();
        const regionCode = localStorage.getItem("regionCode");
        const timeZone = getTimeZone(regionCode);

        if (result.isSuccess) {
          let data = result.data;
          for (let i = 0; i < data.length; i++) {
            const localeDate = convertTimeZone(data[i].regDate, timeZone);

            // Format the date
            const year = localeDate.getFullYear();
            const month = String(localeDate.getMonth() + 1).padStart(2, "0");
            const day = String(localeDate.getDate()).padStart(2, "0");
            data[i].Date = `${year}.${month}.${day}`;

            // Format the time
            const hours = String(localeDate.getHours()).padStart(2, "0");
            const minutes = String(localeDate.getMinutes()).padStart(2, "0");
            data[i].Time = `${hours}:${minutes}`;
          }

          // Sorting logic
          data.sort((a, b) => {
            if (a.Date !== b.Date) {
              return new Date(b.Date) - new Date(a.Date);
            } else {
              return b.Time.localeCompare(a.Time);
            }
          });

          context.state.volHist = data;
        }
      } catch (error) {
        // // console.log("getHistVol ", error);
        return;
      }
    },
  },
};
